
jQuery(function($) {
    
    /******************************************/
        /********** VAR-----------/
    /******************************************/

    var l_window = parseInt($(window).width());
    var header = $('#masthead'); 

    $( ".click_parent" ).click(function() {
        event.preventDefault();
        var href = $(this).find('a').attr('href');
        window.location = href;
       
    });
    $(".click_parent a").click(function(e) {
       // Do something
       e.stopPropagation();
    });

     /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
    if(l_window > 1023){
      action_on_scroll();
    }
    });
 function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }


   /* Click scrool down*/
     $('.btnHomeDown').click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 70 - 0;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });



  /*  ***************************
    AJAX lightbox 
  ******************************** */


   $('a.lightbox_ajax').featherlight({
        targetAttr: 'data-featherlight-custom', 
        type:'ajax',
        loading : '<span class="lightbox-spinner"></span>',
        closeIcon:'<i class="icon-close"></i>',
    });


 /*  ***************************
    CONTENT lightbox  - horaire - page prestation
  ******************************** */


   $('a.btn-horaire-js').featherlight({
       // target: '#horaires', 
      //  type:'html',
        loading : '<span class="lightbox-spinner"></span>',
        closeIcon:'<i class="icon-close"></i>',
    });





    /*  ***************************
    SCROLL TRIGER INTRO 
  ******************************** */

    tween = gsap.to('.HeaderFixe', {
        y: -150,
        ease: "none",
        scrollTrigger: {
            trigger: ".Afterheader",
            //start: "bottom bottom",
            end: "top top",
            scrub: 1
        }
    });




     /*  ***************************
    SCROLL TRIGER INTRO TXT
  ******************************** */

    tween = gsap.from('.very_bigtitle-container', {
        y: "-20%",
        ease: "none",
        scrollTrigger: {
            trigger: ".very_bigtitle",
            //start: "bottom bottom",
            end: "top top",
            scrub: 1
        }
    });


 /*  ***************************
    SCROLL TRIGER PETITES ANIMATIONS  
  ******************************** */
     const titleWidthBorder = gsap.utils.toArray('.titleSection--widthborder');
     titleWidthBorder.forEach((itemtitle,i) => {
       
     let border = itemtitle.querySelector('.titleSection__border');

        tween = gsap.to(border, {
            width: '100%',
            ease: "none",
            scrollTrigger: {
                trigger: itemtitle,
                start: "bottom bottom",
                end: "center center",
                scrub: 1
            }
        });
    });

      /*  ***************************
    SCROLL TRIGER BORDER BHOME
  ******************************** */
    const homePostWidthBorder = gsap.utils.toArray('.AsidePost-Title');
     homePostWidthBorder.forEach((itemtitle,i) => {
       
     let border = itemtitle.querySelector('.anim_border');

        tween = gsap.to(border, {
            width: '100%',
            ease: "none",
            scrollTrigger: {
                trigger: itemtitle,
                start: "bottom bottom",
                end: "center center",
                scrub: 1
            }
        });
    });



  /* ***************************
    SCROLL TRIGER FOOTER BOTTOM 
  ******************************** */

    tween = gsap.from('.big_slogan span', {
        width: '100%',
        ease: "none",
        scrollTrigger: {
            trigger: ".before_footer",
            start: "bottom bottom",
            end: "+=180px",
            scrub: 1
        }
    });


    /* ***************************
    ANIMATIONS ACCUEIL  
  ******************************** */
    if(l_window > 1350){

     tween = gsap.from('.HomeConfiance-L', {
        x: '-100px',
        ease: "none",
        scrollTrigger: {
            trigger: ".HomeConfiance",
           // start: "bottom bottom",
            end:"+300px",
            scrub: 1
        }
    });
    tween = gsap.from('.HomeConfiance-R', {
        x: '100px',
        ease: "none",
        scrollTrigger: {
            trigger: ".HomeConfiance",
           // start: "bottom bottom",
            end:"+300px",
            scrub: 1
        }
    });
}

    /*  ***************************
    SCROLL TRIGER ANIM BLOC HOME
  ******************************** */
     const anim_top_elt = gsap.utils.toArray('.anim_top_elt');
     anim_top_elt.forEach((item_top_elt,i) => {
       
 
        tween = gsap.from(item_top_elt, {
            y: '15%',
            ease: "none",
            scrollTrigger: {
                trigger: item_top_elt,
               // start: "top top",
                end: " center center",
                scrub: 1
            }
        });
    });



   /*  ***************************
    TABS SPECIAL PRESTATION
  ******************************** */

    if(l_window > 1024){
        $(".TabPrestaContent-Item .HideElt").hide();
        $(".TabPrestaContent-Item:first").addClass('active_content').find('.HideElt').show();
    }else{
         $(".TabPrestaContent-Item").hide();
         $(".TabPrestaContent-Item:first").addClass('active_content').show();
    }
  /* if in tab mode */
    $(".TabPrestaLis li").click(function() {

      var activeTab = $(this).attr("rel");
      

       if($(this).hasClass('active')){
        // $("#"+activeTab).slideUp(400); 
        // $(this).removeClass('active');
        // $('.TabPrestaLis').removeClass('active');

      }else{

        $(this).addClass('active');

      
        let tween_img = gsap.to(".active_content .SP-imagebg", {x:'100%', delay:0.5,duration: 0.5, ease:Power2.easeOut});
        let tween_containTxt = gsap.to(".active_content .SP-Container", {delay:0,x:'-100%', duration: 0.6, ease:Power3.easeOut}); // onComplete: AppearNewPrestation, onCompleteParams:[activeTab]

        AppearNewPrestation(activeTab);

         //$(".active_content").find('.SP-imagebg').hide(300);
        // $(".active_content")
         // $(".active_content").find('.SP-Container').slideUp(200, function(){
         //    $("#"+activeTab).addClass('active_content');   
         //    $("#"+activeTab).find('.SP-imagebg').show(300);
           
         //    setTimeout(function() {
         //       $("#"+activeTab).find('.SP-Container').slideDown(300);
         //    },
         //    250);
         // });
       // $(".active_content").removeClass('active_content');
        
        $(".TabPrestaLis li").removeClass("active");
        $(this).addClass("active");

       $(".js-Tabs-Inner-Title").removeClass("d_active");
       $(".js-Tabs-Inner-Title[rel^='"+activeTab+"']").addClass("d_active");

      }
    
    });

    function AppearNewPrestation(activeTab){
       // $('.active_content .SP-Container').css('display', 'none');
       // $('.active_content .SP-imagebg').css('display', 'none');
        $(".active_content").removeClass('active_content');
        
        $("#"+activeTab+" .SP-Container").css('display', 'block');
        $("#"+activeTab+" .SP-imagebg").css('display', 'block');

        let tween_img = gsap.fromTo("#"+activeTab+" .SP-imagebg", {x:'-100%'},{x:'0%', duration: 0.5,delay:0.4, ease:Power1.easeOut});
        let tween_containTxt = gsap.fromTo("#"+activeTab+" .SP-Container", {x:'-100%'},{x:'0%', delay:0.3, duration: 1, ease: Power4.easeOut});

         $("#"+activeTab).addClass('active_content');

      //  let tween_img = gsap.to(".active_content .SP-imagebg", {x:'-100%', duration: 1.2, ease:Power4.easeOut});
       // let tween_containTxt = gsap.to(".active_content .SP-Container", {delay:1,x:'-100%', duration: 0.3, ease:Power4.easeOut,onComplete: AppearNewPrestation});

    }
  /* if in drawer mode */
  $(".js-Tabs-Inner-Title").click(function() {
      

      
      if($(this).next().css('display') == 'none'){
          $(".TabPrestaContent-Item").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(".js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        $(".TabPrestaLis li").removeClass("active");
        $(".TabPrestaLis li[rel^='"+d_activeTab+"']").addClass("active");

      if(l_window < 1025){

        $('html, body').animate({scrollTop: $(this).offset().top-70}, 500);
      
      }

    }else{
      $(this).next().slideUp(400);
      $(".js-Tabs-Inner-Title, .TabPrestaLis li").removeClass("d_active");
    }
    });


    $('.TabPrestaLis li').first().addClass("active");




    /******************************************/
    /******* GALERIE DESSOUS PRESTATION *****/
    /******************************************/

      /* Gallery dans la page d'accueil 2 * 2 pour les études de cas */
    $('.Gallery-Prestation').slick({
          arrows: true,
        //  autoplay:true,
        //  autoplaySpeed: 6000,
          slidesToScroll: 1,
          slidesToShow: 1,
          dots:false,
          pauseOnFocus:false,
          pauseOnHover:false,
          infinite:true,
          centerMode: true
          // responsive: [
          //   {
          //     breakpoint: 370,
          //     settings: {
          //       slidesToShow: 1,
          //       slidesToScroll: 1,
          //       infinite: true,
          //       dots: true
          //     }
          //   }
          // ]
    });


    $('.to_nicedropdown-js').niceSelect();


   });